import React from 'react'
import clsx from 'clsx'
import styles from './MapLocation.module.scss'
import {
    getCurrentPosition,
    DEFAULT_LAT,
    DEFAULT_LNG,
} from '../../../utils/geolocation'
import { handleGeocoder } from '../../../utils/handleGeocoder'
import { PositionType } from '../../../type/PositionType'

// lat and lng for default position – fallback to Náměstí Míru if env not set
const defaultLat =
    Number(window.env.REACT_APP_DEFAULT_CENTER_LAT) || DEFAULT_LAT
const defaultLng =
    Number(window.env.REACT_APP_DEFAULT_CENTER_LNG) || DEFAULT_LNG

interface MapLocationProps {
    setGeolocation: React.Dispatch<
        React.SetStateAction<undefined | google.maps.LatLngLiteral>
    >
    setPosition: (position: PositionType) => void
    geolocation?: google.maps.LatLngLiteral
    className?: string
}

export const MapLocation = ({
    className,
    setGeolocation,
    setPosition,
    geolocation,
}: MapLocationProps) => {
    const [loading, setLoading] = React.useState(false)

    const handleSuccess = (lat: number, lng: number) => {
        if (
            typeof google !== 'undefined' &&
            google.maps &&
            google.maps.Geocoder
        ) {
            handleGeocoder(
                lat,
                lng,
                defaultLat,
                defaultLng,
                (pos) => {
                    setPosition(pos)
                    setLoading(false)
                },
                setGeolocation
            )
        } else {
            // Fallback if google maps is not loaded/blocked
            setGeolocation({ lat, lng })
            setLoading(false)
        }
    }

    const handleClick = () => {
        if (loading) return

        // If we already have a GPS location confirmed in Praha (from the background watcher)
        // use it immediately — no need to re-run the async geocoder check.
        // geolocation is only ever set by handleGeocoder when Praha is confirmed.
        if (geolocation) {
            setPosition(geolocation)
            setGeolocation(geolocation)
            return
        }

        setLoading(true)
        // No cached location yet — get a fresh GPS fix and run Praha check
        getCurrentPosition({
            onSuccess: ({ coords: { latitude: lat, longitude: lng } }) => {
                handleSuccess(lat, lng)
            },
            onError: (e) => {
                setLoading(false)
                console.log(`Error ${e.code}: ${e.message}`)
                window.alert(
                    e.code === 1
                        ? 'Přístup k poloze není povolen. Pro zobrazení Vaší lokace povolte sdílení a aktualizujte stránku.'
                        : 'Vaši polohu se nepodařilo získat. Zkuste to prosím znovu za chvíli.'
                )
            },
        })
    }

    return (
        <div
            onClick={handleClick}
            className={clsx(
                styles.wrapper,
                className,
                loading && styles.loading
            )}
        >
            <img src="/img/layout/map-control-location.svg" alt="" />
        </div>
    )
}
